// extracted by mini-css-extract-plugin
module.exports = {"recommendCard__thumbnailImage":"recommendCard__thumbnailImage","recommendCard__thumbnailImage--wide":"recommendCard__thumbnailImage--wide"};